import gql from 'graphql-tag';
//Used in information block on top
export default gql`
query listFA_UserForms{
    fakturaAssist{
    	listFA_UserForms{
			id
			reportGroupID
			defaultFormID
			copies
			printerTray
			printer
			special
			name
	 	}
 	}
}`;

